import React from 'react'
import './CommandControlHero.scss'

export class CommandControlHero extends React.Component {
  render() {
    return (
      <div
        className="command-control-page-hero"
        style={{ backgroundImage: 'url(/cloudsecopsbg.jpg)' }}
      >
        <div className="overlay" />
        <div className="inner-wrap">
          <div className="text">
            <h1>Command and Control</h1>
            <h2>AI-Enabled Decision Support for Modern Battle Management</h2>
          </div>
        </div>
      </div>
    )
  }
}

export default CommandControlHero
